﻿<script lang="ts">
	import { callApi } from './Api.svelte';
	let popupDisplaying: boolean = false;
	let name: string = "";
	let email: string = "";
	let address: string = "";
	let zipCode: string = "";
	let city: string = "";
	let amount: number = 1;
	let amountError: boolean = false;
	let nameError: boolean = false;
	let emailError: boolean = false;
	let addressError: boolean = false;
    let zipCodeError: boolean = false;
	let cityError: boolean = false;
	let formError: string = "";
	let apiResponse: string = "";

	function resetFormErrors(): void {
		amountError = false;
		nameError = false;
		emailError = false;
		addressError = false;
		zipCodeError = false;
		cityError = false;
		formError = "";
	}

	function formIsValidaded(): boolean {
		if (amount < 1) {
			amountError = true;
			formError = "Vänligen lägg till minst en bok";
		}

		if (name?.length < 2) {
			nameError = true;
			formError = "Vänligen fyll i alla obligatoriska fält";
			return false;
		}	

		if (address?.length < 6) {
			addressError = true;
			formError = "Vänligen fyll i alla obligatoriska fält";
			return false;
		}

		if (zipCode?.length < 4) {
			zipCodeError = true;
			formError = "Vänligen fyll i alla obligatoriska fält";
			return false;
		}

		if (city?.length < 4) {
			cityError = true;
			formError = "Vänligen fyll i alla obligatoriska fält";
			return false;
		}

		if (email?.length < 5) {
			emailError = true;
			formError = "Vänligen fyll i alla obligatoriska fält";
			return false;
		}

		return true;
	}

	async function handleFormSubmission(e): Promise<void> {
		e.preventDefault();
		resetFormErrors();
		if (formIsValidaded()) {
			const apiResp = await callApi(location.origin + '/api/postform', {
				name: name,
				streetAddress: address,
				zipcode: zipCode,
				city: city,
				email: email,
				quantity: amount
			})

			if (apiResp.status == "Error") {
				formError = "Något verkar ha gått fel. Prova gärna igen!"
			} else {
				apiResponse = "Tack! Vi har tagit emot din beställning och en bekräftelse har skickats till dig på mejl"
			}
		}
	}
</script>

<div class="WF_Container">
	<button type="button" class="WF_Button Fat White" on:click={() => (popupDisplaying = true)}>Beställ boken nu!</button>
	<div class="WF_Price_Container">
		<span class="WF_Price_Current Fat">499 kr</span>
		<span class="WF_Price_Previous">
			<span>(850 kr)</span>
			inkl. frakt
		</span>
	</div>
</div>
<div class={`WF_Popup ${popupDisplaying == true ? "WF_Popup--Active" : ""}`}>
	<div class="WF_Popup_Inner">
		<button type="button" class="WF_Popup_Close" on:click={() => (popupDisplaying = false)}>
			<img src="/WesterbergsForlag/Templates/Images/close_Icon.svg" alt="Close icon" />
		</button>
		<h2 class="Headline2">Beställ "De levde på Fjällbacka strand"</h2>
		<p class="Normal">Just nu får du boken för endast 499 kr <span class="StrikeThrough">(850 kr)</span>.<br/>Priset är inklusive frakt och betalning sker med faktura.</p>
		<form class="WF_Form" on:submit={(e) => handleFormSubmission(e)}>
			<div class="WF_Form_Row">
				<label for="customerFirstName" class="WF_Label">Namn</label>
				<input 
					type="text" 
					id="customerName" 
					name="customerName" 
					bind:value={name} 
					class={`WF_Input ${nameError ? "WF_Input--Error" : ""}`}
					autoComplete="name"
				/>
			</div>
			<div class="WF_Form_Row">
				<label for="customerAddress" class="WF_Label">Leverans/fakturaadress</label>
				<input 
					type="text" 
					id="customerAddress" 
					name="customerAddress" 
					bind:value={address} 
					class={`WF_Input ${addressError ? "WF_Input--Error" : ""}`}
					autoComplete="street-address" 
				/>
			</div>
			<div class="WF_Form_Row WF_Form_Row--Split">
				<div class="WF_Form_Row_Column">
					<label for="customerZipCode" class="WF_Label">Postnummer</label>
					<input 
						type="text" 
						id="customerZipCode" 
						name="customerZipCode" 
						bind:value={zipCode} 
						class={`WF_Input ${zipCodeError ? "WF_Input--Error" : ""}`}
						autoComplete="shipping postal-code" 
					/>
				</div>
				<div class="WF_Form_Row_Column">
					<label for="customerCity" class="WF_Label">Ort</label>
					<input 
						type="text" 
						id="customerCity" 
						name="customerCity" 
						bind:value={city} 
						class={`WF_Input ${cityError ? "WF_Input--Error" : ""}`}
						autoComplete="shipping address-level2" 
					/>
				</div>
			</div>
			<div class="WF_Form_Row">
				<label for="customerEmail" class="WF_Label">E-post</label>
				<input 
					type="email" 
					id="customerEmail" 
					name="customerEmail" 
					bind:value={email} 
					class={`WF_Input ${emailError ? "WF_Input--Error" : ""}`}
					autoComplete="email"
				/>
			</div>
			<div class="WF_Form_Row">
				<label for="customerAmount" class="WF_Label">Antal böcker</label>
				<input 
					type="number" 
					id="customerAmount" 
					name="customerAmount" 
					bind:value={amount} 
					class={`WF_Input ${amountError ? "WF_Input--Error" : ""}`}
					autoComplete="off"
					min="1"
					required
				/>
			</div>
			{#if formError?.length >= 1}
				<div class="WF_Form_Error">
					<p class="Normal">{formError}</p>
				</div>
			{/if}
			{#if apiResponse.length >= 1}
				<div class="WF_Form_Success">
					<p class="Normal">{apiResponse}</p>
				</div>
			{/if}
			<div class="WF_Form_Row">
				<button class="WF_Submit Fat White" type="submit">Skicka beställning</button>
			</div>
			<p class="Normal">Boken levereras inom 5 dagar från din beställning.</p>
		</form>
	</div>
</div>
